import useFetch from 'utils/hooks/useFetch'
import { ApiGetCustomerCard, ApiGetCustomerCardList, ApiGetCustomerCardListByCustomerId, ApiInsertCustomerCard, ApiUpdateCustomerCard } from 'utils/constants/api'
import { CheckResponse } from 'utils/helpers'
import { useModal } from 'utils/context/ModalContext'

export function CustomerCardService() {
    const { showFail } = useModal()

    const { fetch: apiCreateCustomerCard } = useFetch(ApiInsertCustomerCard)
    const { fetch: apiUpdateCustomerCard } = useFetch(ApiUpdateCustomerCard)
    const { fetch: apiGetCustomerCardById } = useFetch(ApiGetCustomerCard)
    const { fetch: apiGetCustomerCardList } = useFetch(ApiGetCustomerCardList)
    const { fetch: apiGetCustomerCardListByCustomerId } = useFetch(ApiGetCustomerCardListByCustomerId)
 
    const fetchCreateCustomerCard = async (
        customerId, 
        cardNumber, 
        bankId, 
        cardVendorId, 
        expiredMonth, 
        expiredYear, 
        vcc, 
        mdr,
        mdrQris,
        mdrPl,
        mdrPlQris,
        dueDate,
        billingDate,
        cardLimit
    ) => {
        const res = await apiCreateCustomerCard({
            data:{
                customerId,
                cardNumber,
                bankId,
                cardVendorId,
                expiredMonth,
                expiredYear,
                vcc,
                mdr,
                mdrQris,
                mdrPl,
                mdrPlQris,
                dueDate,
                billingDate,
                cardLimit
            }
        })
        
        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchUpdateCustomerCard = async (
        customerCardId, 
        customerId, 
        cardNumber, 
        bankId, 
        cardVendorId, 
        expiredMonth, 
        expiredYear, 
        vcc, 
        mdr,
        mdrQris,
        mdrPl,
        mdrPlQris,
        dueDate,
        billingDate,
        cardLimit
    ) => {
        const res = await apiUpdateCustomerCard({
            data:{
                customerCardId,
                customerId,
                cardNumber,
                bankId,
                cardVendorId,
                expiredMonth,
                expiredYear,
                vcc,
                mdr,
                mdrQris,
                mdrPl,
                mdrPlQris,
                dueDate,
                billingDate,
                cardLimit
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchCustomerCardById = async(customerCardId) => {
        const res =  await apiGetCustomerCardById({
            data: {
                customerCardId
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchCustomerCardList = async (
        customerName, 
        cardNumber, 
        bankId, 
        cardVendorId, 
        status, 
        pageSize, 
        pageIndex
    ) => {
        const res = await apiGetCustomerCardList({
            data: {
                customerName,
                cardNumber,
                bankId,
                cardVendorId,
                status,
                pageSize,
                pageIndex
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchCustomerCardListByCustomerId = async (customerId) => {
        const res = await apiGetCustomerCardListByCustomerId({
            data: {
                customerId
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    return {
        fetchCreateCustomerCard,
        fetchUpdateCustomerCard,
        fetchCustomerCardById,
        fetchCustomerCardList,
        fetchCustomerCardListByCustomerId
    }
}